import * as constants from './constants';

export const toggleTopShow=(show)=>({
    type:constants.SHOW_SIDE_BAR,
    show
})